import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "dictionary__header" }
const _hoisted_3 = { class: "dictionary__transcription" }
const _hoisted_4 = { class: "dictionary__content" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "dictionary__add-transcription"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["onKeydown"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("table", {
    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setTranscription(null, '')))
  }, [
    (_ctx.currentDictionary != null)
      ? (_openBlock(), _createElementBlock("caption", _hoisted_1, _toDisplayString(_ctx.currentDictionary.title), 1))
      : _createCommentVNode("", true),
    _createElementVNode("thead", _hoisted_2, [
      _createElementVNode("tr", null, [
        _createElementVNode("th", null, _toDisplayString(_ctx.Ti18N("dictionary.word")), 1),
        _createElementVNode("th", _hoisted_3, _toDisplayString(_ctx.Ti18N("dictionary.transcription")), 1),
        _createElementVNode("th", null, _toDisplayString(_ctx.Ti18N("dictionary.translate")), 1)
      ])
    ]),
    _createElementVNode("tbody", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedWords, (wordInfo, index) => {
        return (_openBlock(), _createElementBlock("tr", {
          key: index,
          class: "dictionary__item"
        }, [
          _createElementVNode("td", null, _toDisplayString(wordInfo.english), 1),
          (_ctx.transcription != wordInfo.english)
            ? (_openBlock(), _createElementBlock("td", {
                key: 0,
                class: "dictionary__transcription",
                onClick: _withModifiers(($event: any) => (_ctx.setTranscription(wordInfo.english, wordInfo.transcription)), ["stop"])
              }, [
                (wordInfo?.transcription == null)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.Ti18N("dictionary.addTranscription")), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(wordInfo.transcription), 1))
              ], 8, _hoisted_5))
            : (_openBlock(), _createElementBlock("td", {
                key: 1,
                class: "dictionary__transcription",
                onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
              }, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newTranscription) = $event)),
                  type: "text",
                  onKeydown: [
                    _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (_ctx.setTranscription(null, '')), ["stop"]), ["esc"])),
                    _withKeys(_withModifiers(($event: any) => (_ctx.saveTranscription(wordInfo)), ["stop"]), ["enter"])
                  ]
                }, null, 40, _hoisted_8), [
                  [_vModelText, _ctx.newTranscription]
                ])
              ])),
          _createElementVNode("td", null, _toDisplayString(wordInfo.russian), 1)
        ]))
      }), 128))
    ])
  ]))
}